import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq: HttpRequest<any>;
    const cookieSplit = document.cookie.split(';');
    const xsrfToken = this.cookieToToken(cookieSplit);

    if (xsrfToken != null) {
      authReq = req.clone({
        headers: req.headers
          .set("X-XSRF-TOKEN", xsrfToken)
      });
    } else {
      authReq = req.clone({
        headers: req.headers
      });
    }

    return next.handle(authReq);
  }

  cookieToToken(cookieSplit: string[]): string {
    let token = null;
    cookieSplit.forEach((c?) => {
      if (c.includes("XSRF-TOKEN")) {
        token = c.split("=")[1];
      }
    })
    return token;
  }

}
